import http from './http';

export async function handlerGetBadges() {
  const { data } = await http.get('/api/handler/badges');
  return data;
}

